import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BankAccount } from '@payments/models/payment-preferences-page-view-model';

@Component({
  template: '',
})
export class BankDetailRowComponent {
  @Input() bankDetail: BankAccount;
  @Input() isAutopay: boolean;
  @Output() moreOptionsEmit: EventEmitter<{
    event: any;
    bankAccount: BankAccount;
  }> = new EventEmitter();

  openMoreOptions(event: any = null) {
    this.moreOptionsEmit.emit({ event, bankAccount: this.bankDetail });
  }
}
